import { range } from 'lodash';

import * as OvationsApi from 'core/ovations-api';
import { mockClaimDetail } from './claimDetail';

export const mockDuplicateFlags: OvationsApi.Types.DuplicateFlag[] = range(1, 7).map((i) => ({
    isDuplicate: true,
    claim: {
        ...mockClaimDetail,
        id: `__${i}__`,
        number: i,
    },
}));

export const mockDuplicateFlag = mockDuplicateFlags[0];
